import * as R from "react";
import { SemanticType as a } from "./MetaModel.js";
function L(E, n) {
  return /* @__PURE__ */ R.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: n
  }, E), /* @__PURE__ */ R.createElement("path", {
    fillRule: "evenodd",
    d: "M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z",
    clipRule: "evenodd"
  }));
}
const e = R.forwardRef(L);
function A(E, n) {
  return /* @__PURE__ */ R.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: n
  }, E), /* @__PURE__ */ R.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
  }));
}
const s = R.forwardRef(A);
var T = /* @__PURE__ */ ((E) => (E.DICT_ENTRIES = "dictEntries", E.PATTERN = "pattern", E.SCALAR = "scalar", E.RANGE = "range", E))(T || {}), _ = /* @__PURE__ */ ((E) => (E.negate = "negate", E.default = "default", E))(_ || {});
const N = /* @__PURE__ */ new Map([
  ["default", e],
  ["negate", s]
]);
var c = /* @__PURE__ */ ((E) => (E.CHART = "CHART", E.QUERY = "QUERY", E))(c || {}), o = /* @__PURE__ */ ((E) => (E.IN = "In", E.Like = "Like", E.Match = "Match", E.BETWEEN = "BETWEEN", E.GT = "GT", E.GTE = "GTE", E.LT = "LT", E.LTE = "LTE", E.EQ = "EQ", E))(o || {}), T = /* @__PURE__ */ ((E) => (E.dimension = "dimension", E.metric = "metric", E))(T || {}), r = /* @__PURE__ */ ((E) => (E.VALUE_SELECTION = "VALUE_SELECTION", E.INCLUDE = "INCLUDE", E.START_WITH = "START_WITH", E.END_WITH = "END_WITH", E.REGEX = "REGEX", E.GREATER = "GREATER", E.GREATER_OR_EQ = "GREATER_OR_EQ", E.LOWER = "LOWER", E.LOWER_OR_EQ = "LOWER_OR_EQ", E.BETWEEN = "BETWEEN", E.EQUAL = "EQUAL", E))(r || {});
const t = {
  [a.STRING]: [
    "VALUE_SELECTION",
    "INCLUDE",
    "START_WITH",
    "END_WITH",
    "REGEX"
    /* REGEX */
  ],
  [a.NUMBER]: [
    "VALUE_SELECTION",
    "GREATER",
    "GREATER_OR_EQ",
    "LOWER",
    "LOWER_OR_EQ",
    "BETWEEN"
    /* BETWEEN */
  ],
  [a.DATE]: [
    "VALUE_SELECTION"
    /* VALUE_SELECTION */
  ],
  [a.UUID]: [
    "VALUE_SELECTION"
    /* VALUE_SELECTION */
  ],
  [a.DATETIME]: [
    "VALUE_SELECTION"
    /* VALUE_SELECTION */
  ],
  metric: [
    "GREATER",
    "GREATER_OR_EQ",
    "LOWER",
    "LOWER_OR_EQ",
    "EQUAL",
    "BETWEEN"
    /* BETWEEN */
  ]
};
export {
  r as F,
  c as S,
  _ as a,
  o as b,
  T as c,
  s as d,
  t as e,
  N as f,
  e as g
};
//# sourceMappingURL=filters-Cwo0Aj2k.js.map
